export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business.d4bde25.svg";